export const defaultLang = "en";
export const supportedLanguages = [
  { code: "en", name: "English", icon: "gb", iconLibrary: "flags", id: "en-US" },
  { code: "de", name: "Deutsch", icon: "de", iconLibrary: "flags", id: "de-DE" },
  { code: "es", name: "Español", icon: "es", iconLibrary: "flags", id: "es-ES" },
  { code: "fr", name: "Français", icon: "fr", iconLibrary: "flags", id: "fr-FR" },
  { code: "lv", name: "Latviešu", icon: "lv", iconLibrary: "flags", id: "lv-LV" },
  { code: "pl", name: "Polski", icon: "pl", iconLibrary: "flags", id: "pl-PL" },
  { code: "ru", name: "Русский", icon: "ru", iconLibrary: "flags", id: "ru-RU" },
  { code: "zh", name: "中文", icon: "cn", iconLibrary: "flags", id: "zh-CN" },
];
